import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const Container = styled.div(
    ({ theme }) => css`
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        margin: ${theme.spacing['8px']};

        > * {
            flex-grow: 1;
        }
    `
);
